import { render } from "./SiteFooter.vue?vue&type=template&id=30e0f7d2"
const script = {}

import exportComponent from "/var/www/bip/bip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__